import { t as e } from "../utils-DiFe-_ei.js";
import { t } from "../dist-B6xjZgdF.js";
import "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/foundations/skeleton/skeleton.tsx
var r = t("bg-muted/70 border border-border/60 relative overflow-hidden", {
	variants: { variant: {
		rect: "rounded-md",
		circle: "rounded-full",
		text: "rounded-sm h-[1em]"
	} },
	defaultVariants: { variant: "rect" }
});
function i({ className: t, variant: i, as: a = "div", ...o }) {
	return /* @__PURE__ */ n(a, {
		className: e(r({ variant: i }), t),
		"data-slot": "skeleton",
		...o,
		children: /* @__PURE__ */ n(a, { className: "animate-shimmer absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent" })
	});
}
//#endregion
export { i as Skeleton, r as skeletonVariants };

//# sourceMappingURL=skeleton.js.map